import styled from "@emotion/styled";
import { motion } from "framer-motion";

export const HeroContainer = styled(motion.div)`
  overflow: hidden;
  height: 240px;

  @container (min-width: 460px) {
    height: 420px;
  }

  @container (min-width: 768px) {
    height: 500px;
  }
`;

export const HeroInner = styled.div`
  display: flex;
  height: 100%;
`;

export const HeroSlide = styled.div`
  flex: 0 0 100%;
  min-width: 0;
  height: 100%;
  background-size: cover;
  background-position: center;
`;

export const HeroSlideContainer = styled(motion.div)`
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding: ${(props) => props.theme.spacing.xl}
    ${(props) => props.theme.spacing.lg};
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;

// .embla {
//   overflow: hidden;
//   /* border: 1px solid red; */
//   height: 300px;
// }
// .embla__container {
//   display: flex;
//   height: 100%;
// }
// .embla__slide {
//   flex: 0 0 100%;
//   min-width: 0;
//   height: 100%;
// }
